import { render, staticRenderFns } from "./SamanBankAccountsAccessModal.vue?vue&type=template&id=7727f8da&scoped=true"
import script from "./SamanBankAccountsAccessModal.vue?vue&type=script&lang=js"
export * from "./SamanBankAccountsAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7727f8da",
  null
  
)

export default component.exports